module.exports = __webpack_public_path__ + "img/LTS_ICAZ.b171769c.gif";